import { render, staticRenderFns } from "./BICompetitorSummary.vue?vue&type=template&id=61cdf389"
import script from "./BICompetitorSummary.vue?vue&type=script&lang=js"
export * from "./BICompetitorSummary.vue?vue&type=script&lang=js"
import style0 from "./BICompetitorSummary.vue?vue&type=style&index=0&id=61cdf389&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports